import React from 'react';
import './less/period.less';
import { Card } from 'antd';
import { Radio } from 'antd';


const Period = () => {


    return (

        <Card title="انتخاب دوره">
            
            <Radio.Group defaultValue="a" buttonStyle="solid">
                <Radio.Button value="a">
                    <b>یک ماهه</b>
                </Radio.Button>
                <Radio.Button value="b">
                    <b>دو ماهه</b>

                    <small>۱۰ درصد تخفیف</small>
                </Radio.Button>
                <Radio.Button value="c">
                    <b>سه ماهه</b>

                    <small>۱۰ درصد تخفیف</small>
                </Radio.Button>
                <Radio.Button value="d">
                    <b>شش ماهه</b>

                    <small>۱۰ درصد تخفیف</small>
                </Radio.Button>
                <Radio.Button value="e">
                    <b>نه ماهه</b>

                    <small>۱۰ درصد تخفیف</small>
                </Radio.Button>
                <Radio.Button value="f">
                    <b>یک ساله</b>

                    <small>۱۰ درصد تخفیف</small>
                </Radio.Button>
            </Radio.Group>
        </Card>

    )
}

export default Period;